import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent = null;
  
  try {
    const iconIdentifier = icon || name;
    
    if (typeof iconIdentifier === 'string') {
      // Ensure we check for Fi prefix which is standard for Feather icons in react-icons
      IconComponent = FiIcons[`Fi${iconIdentifier}`] || FiIcons[iconIdentifier];
    } else if (typeof iconIdentifier === 'function' || typeof iconIdentifier === 'object') {
      IconComponent = iconIdentifier;
    }
  } catch (e) {
    // Silent fail to fallback
  }
  
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;